import { computed, reactive, ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import {
  URL,
  USER,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default function useInscription() {
  const { getApi, postApi } = apiCall()
  const listInstitutions = ref([])
  const listUsers = ref([])
  const listGremios = ref([])
  const showConfirmacionEliminar = ref(false)
  const userSelected = ref(null)
  const showLoading = ref(false)
  const showLoadingEmail = ref(false)
  // const listEquiposEditar = ref([])
  const searchQuery = ref('')
  const userData = reactive({
    id_institucion: '',
    nombre: '',
    apellido: '',
    email: '',
    rol: '',
    cadenaEquipos: '',
    arrayEquipos: [],
    permissionPlayer: false,
    permissionAuditoria: false,
  })
  const tableColumns = [
    // { key: 'nombre', sortable: true },
    // { key: 'apellido', sortable: true },
    { key: 'usuario', sortable: true },
    { key: 'email', sortable: true },
    { key: 'institucion', sortable: true },
    { key: 'rol', sortable: true },
    { key: 'acciones' },
  ]

  function showModalEliminar(item) {
    showConfirmacionEliminar.value = true
    userSelected.value = item
  }

  async function getInstituciones(idTorneo) {
    listInstitutions.value = []
    const path = `ApiUsuario/getInstituciones/${idTorneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.data.forEach(element => {
        const obj = {
          label: element.nombre,
          value: element.id_institucion,
          id_disciplina: element.id_disciplina,
        }
        listInstitutions.value.push(obj)
      })
    } else {
      listInstitutions.value = []
    }
  }
  async function getUsers(rol) {
    showLoading.value = true
    listUsers.value = []
    const path = `ApiUsuario/getUsuarios/${rol}/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      listUsers.value = data.data
    } else {
      listUsers.value = []
    }
    showLoading.value = false
  }
  async function getGremios() {
    showLoading.value = true
    listGremios.value = []
    const path = 'ApiArbitros/getGremios'
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      listGremios.value = data.data
    } else {
      listGremios.value = []
    }
    showLoading.value = false
  }
  async function getEquiposEditar(idUsuario, idInstitucion) {
    // listEquiposEditar.value = []
    const path = `ApiUsuario/getEquiposParaUsuarioEnActualizar/${idUsuario}/${idInstitucion}`
    const data = await getApi(URL, path)
    return data.data
    // console.log(data)
    // if (data.flag === 's') {
    //   listUsers.value = data.data
    // } else {
    //   listUsers.value = []
    // }
  }
  async function deleteUser(item) {
    const path = 'ApiUsuario/deleteUsuario'
    const dataDelete = {
      idUsuario: item.id_usuario,
    }
    const data = await postApi(URL, path, dataDelete)
    showConfirmacionEliminar.value = false
    getUsers(USER().rol)
    if (data.flag === 'si') {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'USUARIO eliminado exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ERROR no se pudo eliminar',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
  }
  async function reSendEmail(item) {
    showLoadingEmail.value = true
    document.getElementById(`load${item.id_usuario}`).style.visibility = 'visible'
    const path = 'ApiUsuario/sendUserMail/r/a/a/a/a/a'
    const dataDelete = {
      idUsuario: item.id_usuario,
    }
    const data = await postApi(URL, path, dataDelete)
    if (data.flag === 'si') {
      showLoadingEmail.value = false
      document.getElementById(`load${item.id_usuario}`).style.visibility = 'hidden'
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'USUARIO reenviado exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'USUARIO no se pudo reenviar',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
  }
  const listUsersFilter = computed(
    () =>
      // eslint-disable-next-line
      listUsers.value.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.nombre
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          // eslint-disable-next-line
          element.apellido
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          element.rol.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          element.email_user
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          // eslint-disable-next-line
          element.institucion
            .toLowerCase()
            // eslint-disable-next-line
            .includes(searchQuery.value.toLowerCase())
        // eslint-disable-next-line
      )
    // eslint-disable-next-line
  )
  const listGremiosFilter = computed(
    () =>
      // eslint-disable-next-line
      listGremios.value.filter(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.nombre
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          element.rol.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          element.email_user
            .toLowerCase()
            .includes(searchQuery.value.toLowerCase()) ||
          // eslint-disable-next-line
          element.gremio
            .toLowerCase()
            // eslint-disable-next-line
            .includes(searchQuery.value.toLowerCase())
        // eslint-disable-next-line
      )
    // eslint-disable-next-line
  )
  return {
    getApi,
    getInstituciones,
    listInstitutions,
    userData,
    tableColumns,
    getUsers,
    getGremios,
    listUsers,
    listGremios,
    listUsersFilter,
    listGremiosFilter,
    searchQuery,
    getEquiposEditar,
    showConfirmacionEliminar,
    showModalEliminar,
    deleteUser,
    userSelected,
    showLoading,
    reSendEmail,
    showLoadingEmail,
  }
}
